// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Photos__row":"sq_a bhe_a bhe_r bhe_j","Photos__img":"sq_b bhe_b"};